import { type ReactNode } from "react";

interface PaneSectionProps {
  title: string;
  children: ReactNode;
}

/**
 * One titled section of the analytics review pane.
 *
 * **It never decides its own absence.** A section with nothing to show is not
 * rendered at all — no heading, no placeholder — and what counts as nothing
 * differs per section: an empty output list, a starred set no card resolved for,
 * a missing link. A shell that hid itself on falsy children would answer that
 * question in one place for five sections that answer it differently, so each
 * caller returns null before reaching here.
 */
export function PaneSection({ title, children }: PaneSectionProps) {
  return (
    <section className="space-y-2">
      <h3 className="text-xs uppercase tracking-wider text-font-secondary">
        {title}
      </h3>
      {children}
    </section>
  );
}
